// extracted by mini-css-extract-plugin
module.exports = {"container":"blogGrid_container__RjxoV","results":"blogGrid_results__7FQcN","pagination":"blogGrid_pagination__0aLcV"};